<template>
  <div>
    <Header/>
    <TopLink/>
    <section class="section" id="tribute_form">
      <div class="has-text-centered">
        <h1 class="title section-title is-size-1">Tributes</h1>
        <div class="columns is-centered">
          <div class="column is-half">
            <div class="padding-top is-size-5">
              <p>
                Below are some messages friends and family
                have written for Yiqing.<br/><span class="text-ch">以下是部分亲友留言。</span>
              </p>
              <p>
                If you would like to write a tribute,
                please click the button below.
              </p>
            </div>
            <div class="padding-top">
              <b-collapse :open.sync="isFormOpen" aria-id="form-toggle">
                <button class="button button-form-toggle is-large"
                        slot="trigger"
                        aria-controls="form-toggle">
                        <span v-if="!isFormOpen">Share a Tribute (留言)</span><br/>
                        <span v-if="isFormOpen">Hide Form</span></button>
                <transition name="fade">
                  <div class="container form-container padding-top">
                    <div class="notification">
                      <div class="content">
                        <p>Share a story or tribute for Yiqing.</p>
                        <p>分享您对伊青的怀念。</p>
                        <div class="container">
                           <b-loading ref="form-loading"
                                      :is-full-page="false"
                                      :active.sync="isSubmitting"
                                      :can-cancel="false"></b-loading>
                          <TributeForm ref="tributeForm"
                            v-on:submit="onSubmit"
                            v-bind:class="{ faded: isSubmitting }"
                            v-bind:disabled="isSubmitting"></TributeForm>
                        </div>
                      </div>
                    </div>
                  </div>
                </transition>
              </b-collapse>
            </div>
          </div>
        </div>
      </div>
    </section>
    <hr/>
    <div>
      <section class="section"
               ref="gallery-loading"
               v-infinite-scroll="loadMoreTributes"
               infinite-scroll-disabled="stopScrolling"
               infinite-scroll-distance="10">
        <div class="container">
          <div class="columns is-centered">
            <div class="column is-2 is-hidden-mobile is-quarter-widescreen">
              <div class="tiles is-ancestor">
                <div class="tiles is-parent is-vertical side-images"
                     v-prlx="sidescrollImagePlxSettings">
                  <img v-for="(src, index) in sidescrollImages"
                       v-bind:key="index"
                       class="tiles"
                       :src="src"
                       />
                </div>
              </div>
            </div>
            <div class="column is-12 is-8-widescreen">
              <TributeGallery v-bind:tributes="tributes" />
              <div class="container" v-if="isLoading">
                Loading...
              </div>
              <div class="container"
                   v-if="showEmptyTributes">
                No tributes have been submitted yet.
              </div>
              <div class="container"
                   v-if="showEndOfTributes">
                You have reached the end of tributes.
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase';
import axios from 'axios';
import Header from '@/components/Header.vue';
import TributeForm from '@/components/TributeForm.vue';
import TributeGallery from '@/components/TributeGallery.vue';
import TopLink from '@/components/TopLink.vue';

const fb = require('@/firebaseConfig.js');

export default {
  name: 'Content',
  components: {
    Header,
    TributeForm,
    TributeGallery,
    TopLink,
  },
  data() {
    return {
      isLoading: true,
      showEmptyTributes: false,
      showEndOfTributes: false,
      url: process.env.VUE_APP_CF_URL,
      errorMsg: '',
      isFormOpen: false,
      isSubmitting: false,
      stopScrolling: false,
      tributes: [],
      scroller: {
        last: undefined,
        pageSize: 10,
      },
      sidescrollImages: [
        'vertical1.jpg',
        'vertical2.jpg',
        'vertical3.jpg',
        'vertsmith.jpg',
      ],
      sidescrollImagePlxSettings: {
        preserveInitialPosition: false,
        limit: { min: -30, max: 30 },
      },
    };
  },
  methods: {
    handleTributesError(e) {
      this.isLoading = false;
      this.displayError(
        `Unable to load more tributes (${e.message}).`,
      );
    },
    appendTributes(resp) {
      if (resp.docs.length > 0) {
        this.scroller.last = resp.docs[resp.docs.length - 1];
        resp.forEach((d) => {
          this.tributes.push(d.data());
        });
      } else {
        this.scroller.last = undefined;
        this.stopScrolling = true;
        this.showEndOfTributes = true;
      }
      this.showEmptyTributes = (this.tributes.length === 0);
      this.isLoading = false;
    },
    setTributes(resp) {
      if (resp.docs.length > 0) {
        this.scroller.last = resp.docs[resp.docs.length - 1];
        this.tributes = resp.docs.map((d) => d.data());
      } else {
        this.scroller.last = undefined;
        this.stopScrolling = true;
      }
      this.showEmptyTributes = (this.tributes.length === 0);
      this.isLoading = false;
    },
    loadInitialTributes() {
      this.isLoading = true;
      fb.postsCollection
        .orderBy('created_at.seconds', 'desc')
        .limit(this.scroller.pageSize)
        .get()
        .then(this.setTributes)
        .catch(this.handleTributesError);
    },
    loadMoreTributes() {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      if (this.tributes.length === 0) {
        return;
      }
      if (this.stopScrolling) {
        return;
      }
      if (!this.scroller.last) {
        this.stopScrolling = true;
        return;
      }
      this.isLoading = true;

      fb.postsCollection
        .orderBy('created_at.seconds', 'desc')
        .startAfter(this.scroller.last)
        .limit(this.scroller.pageSize)
        .get()
        .then((resp) => {
          this.appendTributes(resp);
        })
        .catch(this.handleTributesError);
    },
    addTribute(d) {
      this.isSubmitting = true;
      const tributeData = d.formData;
      tributeData.created_at = firebase.firestore.Timestamp.now();
      const postData = {
        token: d.token,
        tribute: tributeData,
      };
      axios.post(process.env.VUE_APP_CF_URL, postData)
        .then(() => {
          this.isFormOpen = false;
          this.loadInitialTributes();
          this.isSubmitting = false;
          this.$refs.tributeForm.initForm();
          this.displaySuccess('Successfully submitted a tribute!');
        })
        .catch((error) => {
          this.isSubmitting = false;
          this.displayError(
            `Unable to submit new tribute, try again: ${error.message}`,
          );
        });
    },
    onSubmit(formData) {
      this.isSubmitting = true;
      this.addTribute(formData);
    },
    displayError(msg) {
      this.$buefy.snackbar.open({
        duration: 5000,
        message: msg,
        type: 'is-danger',
        position: 'is-bottom-left',
        actionText: 'Close',
        queue: false,
      });
    },
    displaySuccess(msg) {
      this.$buefy.snackbar.open({
        duration: 5000,
        message: msg,
        type: 'is-primary',
        position: 'is-bottom-left',
        actionText: 'Close',
        queue: false,
      });
    },
  },
  created() {
    this.loadInitialTributes();
  },
};
</script>
